import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../store/hooks";
import { selectExtension } from "../../../../features/extension/extension.selector";

type TFooterProps = {
  text: string;
  linkText: string;
  link: string;
};

export const Footer = ({ text, link, linkText }: TFooterProps) => {
  const navigate = useNavigate();
  const { isExtension } = useAppSelector(selectExtension);

  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      mt={4}
    >
      <Typography variant="body1" fontSize={14} fontWeight={400}>
        {text}
      </Typography>
      <Button
        variant="text"
        sx={{ fontSize: 14, fontWeight: 700 }}
        onClick={() =>
          isExtension
            ? window.open(
                `${process.env.REACT_APP_SERVER_URL}${link}?from=extension`,
                "_blank",
                "noopener,noreferrer",
              )
            : navigate(link)
        }
      >
        {linkText}
      </Button>
    </Stack>
  );
};
